import { HttpError } from 'react-admin';


const ThrowHttpError = (e) => {
    switch (e.status) {
        case 400:
            if (e.body.errorMessage === 'invalid_request_parameter') {
                throw new HttpError('notification.invalidRequestParameter', e.status, e.body);
            } else if (e.body.errorMessage === 'account_manager_must_exist') {
                throw new HttpError('resources.users.notification.accountManagerMustExist', e.status, e.body);
            } else if (e.body.errorMessage === 'default_rule_cannot_be_deleted') {
                throw new HttpError('resources.operation-rules.notification.defaultRuleUndeletable', e.status, e.body);
            } else if (e.body.errorMessage === 'operation_rule_has_been_used') {
                throw new HttpError('resources.operation-rules.notification.inUseRuleUndeletable', e.status, e.body);
            } else if (e.body.errorMessage === 'operation_rule_with_same_name_already_exists') {
                throw new HttpError('resources.operation-rules.notification.sameNameAlreadyExists', e.status, e.body);
            } else if (e.body.errorMessage === 'operation_rule_has_too_many_reminders') {
                throw new HttpError('resources.operation-rules.notification.tooManyReminders', e.status, e.body);
            } else if (e.body.errorMessage === 'invalid_reminder_timings') {
                throw new HttpError('resources.operation-rules.notification.invalidReminderTimings', e.status, e.body);
            } else if (e.body.errorMessage === 'resource_has_invalid_operation_rule') {
                throw new HttpError('resources.resources.notification.invalidOperationRule', e.status, e.body);
            } else if (e.body.errorMessage === 'exceeded_maximum_contract_limit') {
                throw new HttpError('resources.resources.notification.exceededMaxContractLimit', e.status, e.body);
            } else if (e.body.errorMessage === 'resource_has_another_tenant_setting') {
                throw new HttpError('resources.resources.notification.anotherTenantSetting', e.status, e.body);
            } else if (e.body.errorMessage === 'report_with_same_term_already_exists') {
                throw new HttpError('resources.reports.notification.sameReportAlreadyExists', e.status, e.body);
            } else if (e.body.errorMessage === 'exceeded_maximum_report_limit') {
                throw new HttpError('resources.reports.notification.exceededMaxReportLimit', e.status, e.body)
            } else if (e.body.errorMessage === 'processing_other_report_request') {
                throw new HttpError('resources.reports.notification.processingOtherRequest', e.status, e.body);
            } else if (e.body.errorMessage === 'app_auth_not_configured') {
                throw new HttpError('calendarServiceConfig.appAuthNotConfigured', e.status, e.body);
            } else {
                throw new HttpError('notification.unexpectedError', e.status, e.body);
            }
        case 401:
            throw new HttpError('notification.unauthorized', e.status, e.body);
        case 403:
            throw new HttpError('notification.permissionDenied', e.status, e.body);
        case 404:
            if (e.body.errorMessage === 'user_not_found') {
                throw new HttpError('notification.userNotFound', e.status, e.body);
            } else if (e.body.errorMessage === 'resource_not_found') {
                throw new HttpError('notification.resourceNotFound', e.status, e.body);
            } else if (e.body.errorMessage === 'tenant_not_found	') {
                throw new HttpError('notification.tenantNotFound', e.status, e.body);
            } else if (e.body.errorMessage === 'terminal_not_found') {
                throw new HttpError('notification.terminalNotFound', e.status, e.body);
            } else if (e.body.errorMessage === 'service_not_found') {
                throw new HttpError('notification.serviceNotFound', e.status, e.body);
            } else if (e.body.errorMessage === 'calendar_account_not_found') {
                throw new HttpError('notification.calendarAccountNotFound', e.status, e.body);
            } else {
                throw new HttpError('notification.unexpectedError', e.status, e.body);
            }
        case 409:
            if (e.body.errorMessage === 'already_exists') {
                throw new HttpError('resources.operation-rules.notification.alreadyExists', e.status, e.body);
            }
            throw new HttpError('notification.unexpectedError', e.status, e.body);
        case 500:
            throw new HttpError('notification.internalServerError', e.status, e.body);
        default:
            throw new HttpError('notification.unexpectedError', e.status, e.body);
    }
}

export default ThrowHttpError;